export default "/images/email-unread.svg";